import PropTypes from 'prop-types'
import React from 'react'
import styled from 'react-emotion'
import { StyledButton as Button } from '../../../common/Button'
import Menu from '../../../common/Menu'
import BlockName from './BlockName'
import { BlockViewOptionsContainer } from './BlockViewOptionsContainer'
import SourceButton from './SourceButton'

export const BlockViewOptions = styled(
  ({ className, block, src, originalSource, discuss, t }) => (
    <Menu className={className}>
      {/* Name */}
      <BlockName>{block.name || t('blockOptions.defaultImageName')}</BlockName>

      {/* Source */}
      {originalSource && <SourceButton source={originalSource} />}

      {/* Download */}
      <Button href={src} target="_blank">
        {t('blockOptions.download')}
      </Button>

      {/* Discsuss */}
      <Button onClick={discuss}>{t(['blockOptions.discuss'])}</Button>
    </Menu>
  )
)(({ position }) => ({
  label: 'BlockViewOptions',
  position: 'absolute',
  top: position.top,
  left: position.left,
  cursor: 'default'
}))

BlockViewOptions.propTypes = {
  block: PropTypes.object.isRequired
}

export default BlockViewOptionsContainer(BlockViewOptions)
